import { render, staticRenderFns } from "./eventCombine.vue?vue&type=template&id=0aee443f&scoped=true"
import script from "./eventCombine.vue?vue&type=script&lang=ts"
export * from "./eventCombine.vue?vue&type=script&lang=ts"
import style0 from "./eventCombine.vue?vue&type=style&index=0&id=0aee443f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aee443f",
  null
  
)

export default component.exports